export function getAvatarText(
  input: string | {
    name?: string | null;
    userName?: string | null;
    username?: string | null;
    email?: string | null;
    id?: string | null;
    profile?: { firstName?: string | null; lastName?: string | null } | null;
  } | null | undefined,
  maxChars: 1 | 2 = 2
): string {
  if (!input) return '?';

  let source: string;

  if (typeof input === 'string') {
    source = input;
  } else {
    source = input.name ||
      input.userName ||
      input.username ||
      (input.profile?.firstName && input.profile?.lastName
        ? `${input.profile.firstName} ${input.profile.lastName}`
        : undefined) ||
      input.email ||
      input.id ||
      '?';
  }

  if (!source || source === '?') return '?';
  const cleaned = source.trim();
  if (cleaned.includes('@')) {
    const [local] = cleaned.split('@');
    const parts = local.split(/[._-]/).filter(Boolean);
    if (maxChars === 1) return (parts[0]?.[0] || local[0])?.toUpperCase() || '?';
    return ((parts[0]?.[0] || local[0]) + (parts[1]?.[0] || local[1] || '')).toUpperCase();
  }

  const words = cleaned.split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';

  if (maxChars === 1) {
    return words[0][0]?.toUpperCase() || '?';
  }

  const first = words[0][0]?.toUpperCase() || '';
  const second = words.length > 1
    ? words[words.length - 1][0]?.toUpperCase()
    : words[0][1]?.toUpperCase() || '';

  return (first + second) || '?';
}

export function getAvatarColorIndex(input: string | null | undefined): number {
  if (!input) return 0;
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash) % 12;
}
